import { useUpdateMemberActivation } from 'components/IncidentConfig/hooks/useUpdateMemberActivation';

type ActivationParams = {
  incidentId: string;
  memberUserGuid: string;
  isActivated: boolean;
  declineNote?: string;
};

export const useActivationActions = () => {
  const mutation = useUpdateMemberActivation();

  return {
    ...mutation,
    mutateAsync: ({
      incidentId,
      memberUserGuid,
      isActivated,
      declineNote,
    }: ActivationParams) => {
      return mutation.mutateAsync({
        /* eslint-disable camelcase */
        incident_id: incidentId,
        member_user_guid: memberUserGuid,
        is_activated: isActivated,
        decline_note: isActivated ? undefined : declineNote,
        /* eslint-enable camelcase */
      });
    },
  };
};
